import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OrderHistoryConfirmedUpdateStatusRequest } from "@/features/my-order/features/order-history/features/final-copy/types";
import { OrderHistoryConfirmedApi } from "@/features/my-order/features/order-history/features/final-copy/api";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useIdentity from "@/features/ui/hooks/use-identity";

const usePostOrderHistoryUpdateStatus = (orderSheetSetId: string | null) => {
  const queryClient = useQueryClient();
  const identity = useIdentity();
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const companyId = identity?.company?.id;

  const { mutate: postUpdateStatus } = useMutation({
    mutationKey: ["order-history", "update-status", orderSheetSetId],
    mutationFn: (params: OrderHistoryConfirmedUpdateStatusRequest) =>
      OrderHistoryConfirmedApi.updateStatus(companyType!, companyId!, params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "order-history",
          "detail",
          companyId,
          companyType,
          orderSheetSetId,
        ],
      });
    },
  });

  return {
    postUpdateStatus,
  };
};

export default usePostOrderHistoryUpdateStatus;
